import { createElement, forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import invariant from 'invariant';

import useToastNotifications from 'Hooks/useToastNotifications';

export default function withToastNotifications(Component) {
  const displayName = `withToastNotifications(${ (Component.displayName || Component.name || 'Component') })`;

  const WithToastNotifications = forwardRef((props, ref) => {
    const toast = useToastNotifications();
    invariant(toast, `You should not use <${displayName} /> outside a <ToastNotificationProvider />`);
    return createElement(Component, {
      toast,
      ref,
      ...props
    });
  });

  WithToastNotifications.displayName = displayName;
  WithToastNotifications.WrappedComponent = Component;

  return hoistNonReactStatics(WithToastNotifications, Component);
}
